/* eslint-disable import/no-cycle */
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import actionBroadcastMiddleware from './broadcast/middleware';
import rootReducer from './reducers';
import rootSaga from './sagas';
export default function configureStore(initialState) {
    const sagaMiddleware = createSagaMiddleware();
    const middleware = applyMiddleware(thunk, sagaMiddleware, actionBroadcastMiddleware);
    const store = createStore(rootReducer, initialState, process.env.NODE_ENV === 'production'
        ? middleware
        : composeWithDevTools(middleware));
    sagaMiddleware.run(rootSaga);
    return store;
}
